<footer class="border-t border-slate-200 bg-slate-100">
  <div class="w-full px-4 sm:px-6 lg:px-10 xl:px-16 py-8 sm:py-10">
    <div class="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-10 mb-8">
      <!-- Description : plus d’espace -->
      <div class="md:col-span-6">
        <a
          [routerLink]="paths.segments('home')"
          class="inline-block focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 rounded-md"
          [attr.aria-label]="'COMMON.HOME_ARIA' | translate"
        >
          <img
            src="/logo_phrase.png"
            alt="Logo Unelya"
            class="h-9 w-auto object-contain"
            width="140"
            height="36"
          />
        </a>
        <p class="mt-4 text-sm text-slate-700 leading-6 max-w-xl">
          {{ 'FOOTER.DESCRIPTION' | translate }}
        </p>
        <div class="relative mt-8 inline-block" #langMenu>
          <button
            type="button"
            (click)="toggleLangMenu()"
            class="cursor-pointer inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-2 text-xs md:text-sm text-slate-700 shadow-sm hover:bg-slate-50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-100"
            [attr.aria-expanded]="langMenuOpen"
            [attr.aria-label]="'HEADER.CHOOSE_LANGUAGE' | translate"
          >
            <img [src]="lang === 'en' ? '/flags/gb.svg' : '/flags/fr.svg'" [alt]="(lang === 'en' ? 'COMMON.ENGLISH' : 'COMMON.FRENCH') | translate" class="w-5 h-[13px] object-cover" />
            <span class="font-medium">
              {{ (lang === 'en' ? 'COMMON.ENGLISH' : 'COMMON.FRENCH') | translate }}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="size-4 text-slate-500 transition-transform duration-200"
              [class.rotate-180]="langMenuOpen"
              aria-hidden="true"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </button>

          <div
            *ngIf="langMenuOpen"
            class="absolute left-0 bottom-full mb-2 w-44 rounded-lg border border-slate-200 bg-white shadow-sm overflow-hidden"
            role="menu"
          >
            <button
              type="button"
              (click)="setLang('fr')"
              class="cursor-pointer w-full flex items-center justify-between gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 text-left"
              role="menuitem"
            >
              <span class="inline-flex items-center gap-2">
                <img src="/flags/fr.svg" alt="" class="w-5 h-[13px] object-cover" aria-hidden="true" />
                <span>{{ 'COMMON.FRENCH' | translate }}</span>
              </span>
              <span *ngIf="lang === 'fr'" class="text-blue-700 font-semibold">✓</span>
            </button>
            <button
              type="button"
              (click)="setLang('en')"
              class="cursor-pointer w-full flex items-center justify-between gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 text-left"
              role="menuitem"
            >
              <span class="inline-flex items-center gap-2">
                <img src="/flags/gb.svg" alt="" class="w-5 h-[13px] object-cover" aria-hidden="true" />
                <span>{{ 'COMMON.ENGLISH' | translate }}</span>
              </span>
              <span *ngIf="lang === 'en'" class="text-blue-700 font-semibold">✓</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Liens rapides -->
      <div class="md:col-span-3">
        <h3 class="text-lg md:text-xl font-semibold text-slate-900 mb-4">
          {{ 'FOOTER.QUICK_LINKS' | translate }}
        </h3>
        <ul class="space-y-2">
          <li>
            <a [routerLink]="paths.segments('home')" routerLinkActive="text-blue-700" [routerLinkActiveOptions]="{ exact: true }" class="text-sm text-slate-700 hover:text-slate-900 underline-offset-4 hover:underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 rounded">{{ 'HEADER.NAV.HOME' | translate }}</a>
          </li>
          <li>
            <a [routerLink]="paths.segments('programs')" routerLinkActive="text-blue-700" class="text-sm text-slate-700 hover:text-slate-900 underline-offset-4 hover:underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 rounded">{{ 'HEADER.NAV.PROGRAMS' | translate }}</a>
          </li>
          <li>
            <a [routerLink]="paths.segments('degreeRecognition')" routerLinkActive="text-blue-700" class="text-sm text-slate-700 hover:text-slate-900 underline-offset-4 hover:underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 rounded">{{ 'HEADER.NAV.DEGREE_RECOGNITION' | translate }}</a>
          </li>
          <li>
            <a [routerLink]="paths.segments('about')" routerLinkActive="text-blue-700" class="text-sm text-slate-700 hover:text-slate-900 underline-offset-4 hover:underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 rounded">{{ 'HEADER.NAV.ABOUT' | translate }}</a>
          </li>
        </ul>
      </div>

      <!-- Informations -->
      <div class="md:col-span-3">
        <h3 class="text-lg md:text-xl font-semibold text-slate-900 mb-4">
          {{ 'FOOTER.INFORMATION' | translate }}
        </h3>
        <ul class="space-y-2">
          <li>
            <a [routerLink]="paths.segments('terms')" routerLinkActive="text-blue-700" class="text-sm text-slate-700 hover:text-slate-900 underline-offset-4 hover:underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 rounded">{{ 'FOOTER.TERMS' | translate }}</a>
          </li>
          <li>
            <a [routerLink]="paths.segments('termsOfSale')" routerLinkActive="text-blue-700" class="text-sm text-slate-700 hover:text-slate-900 underline-offset-4 hover:underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 rounded">{{ 'FOOTER.TERMS_OF_SALE' | translate }}</a>
          </li>
          <li>
            <a [routerLink]="paths.segments('legalNotice')" routerLinkActive="text-blue-700" class="text-sm text-slate-700 hover:text-slate-900 underline-offset-4 hover:underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 rounded">{{ 'FOOTER.LEGAL_NOTICE' | translate }}</a>
          </li>
          <li>
            <a [routerLink]="paths.segments('privacy')" routerLinkActive="text-blue-700" class="text-sm text-slate-700 hover:text-slate-900 underline-offset-4 hover:underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 rounded">{{ 'FOOTER.PRIVACY' | translate }}</a>
          </li>
          <li>
            <a [routerLink]="paths.segments('cookiePolicy')" routerLinkActive="text-blue-700" class="text-sm text-slate-700 hover:text-slate-900 underline-offset-4 hover:underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 rounded">{{ 'FOOTER.COOKIE_POLICY' | translate }}</a>
          </li>
          <li>
            <button
              type="button"
              (click)="consent.reopen()"
              class="cursor-pointer text-left text-sm text-slate-700 hover:text-slate-900 underline-offset-4 hover:underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 rounded"
            >
              {{ 'FOOTER.MANAGE_COOKIES' | translate }}
            </button>
          </li>
        </ul>
      </div>
    </div>

    <!-- Bas de page : aide / meta (design system text-xs md:text-sm text-slate-600) -->
    <div class="pt-6 border-t border-slate-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
      <p class="text-xs md:text-sm text-slate-600">
        {{ 'FOOTER.COPYRIGHT' | translate: { year: currentYear } }}
      </p>
    </div>
  </div>
</footer>
